import { useEffect, useState } from "react";
import { getAllPayments } from "../service/AdminService";
import { Payment } from "../model/types";
import { Alert } from "../util/Alert";
import { Loading } from "../util/Loading";
import { extractErrorMessage } from "../service/api";

export const PaymentsPage = () => {
  const [payments, setPayments] = useState<Payment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadPayments = async () => {
      setLoading(true);
      try {
        setPayments(await getAllPayments());
      } catch (err) {
        setError(extractErrorMessage(err));
      } finally {
        setLoading(false);
      }
    };

    loadPayments();
  }, []);

  if (loading) {
    return <Loading label="Loading payments..." />;
  }

  return (
    <section className="space-y-6">
      <div className="rounded-3xl bg-white p-6 shadow-sm">
        <p className="text-xs uppercase tracking-[0.24em] text-emerald-700">
          Payments
        </p>
        <h2 className="mt-2 text-3xl font-semibold text-slate-900">
          Payment activity
        </h2>
      </div>
      {error ? (
        <Alert type="failed" message={error} onClose={() => setError("")} />
      ) : null}
      <div className="overflow-hidden rounded-3xl border border-stone-200 bg-white shadow-sm">
        <table className="min-w-full divide-y divide-stone-200 text-sm">
          <thead className="bg-stone-50">
            <tr>
              {["Payment ID", "Order ID", "Amount", "Status", "Reference", "Paid At"].map(
                (heading) => (
                  <th
                    key={heading}
                    className="px-4 py-3 text-left font-semibold text-stone-600"
                  >
                    {heading}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-stone-200">
            {payments.map((payment) => (
              <tr key={payment.paymentId}>
                <td className="px-4 py-3">{payment.paymentId}</td>
                <td className="px-4 py-3">{payment.orderId}</td>
                <td className="px-4 py-3">Rs. {payment.amount.toFixed(2)}</td>
                <td className="px-4 py-3">{payment.status}</td>
                <td className="px-4 py-3">{payment.transactionReference}</td>
                <td className="px-4 py-3">
                  {payment.paidAt ? new Date(payment.paidAt).toLocaleString() : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
